var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgShowerBenches = function SvgShowerBenches(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LABELS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.88,253h55.55a6.85,6.85,0,0,0,0-13.7H290.88a6.85,6.85,0,0,0,0,13.7Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,70a12.72,12.72,0,0,1,10,12.41v4c2.89,4.9,8.73,8.27,15.48,8.27,7.51,0,13.9-4.15,16.35-10v-2.3a12.73,12.73,0,0,1,12.59-12.72V61.55H150Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.09,353.41V307.75h-3.65a23.64,23.64,0,0,1-4.15-.37v46Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.29,307.38l-.28-.05v46.08h.28Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.74,61.55V70A12.74,12.74,0,0,1,91.5,82.38v3.14c2.69,5.36,8.81,9.12,16,9.12,7.51,0,13.9-4.15,16.35-10v-2.3a12.73,12.73,0,0,1,12.3-12.71V61.55Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.74,
    y: 51.42,
    width: 54.37,
    height: 10.13,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.69,51.42V29.11a2,2,0,0,0-2-2H14.58a2,2,0,0,0-2,2V83.86a2,2,0,0,0,2,2H25.69a2,2,0,0,0,2-2V61.55H67.8V51.42Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.04,
    y: 51.42,
    width: 54.37,
    height: 10.13,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.63,27.11H571.52a2,2,0,0,0-2,2V51.42H218.35V61.55H569.52V83.86a2,2,0,0,0,2,2h11.11a2,2,0,0,0,2-2V29.11A2,2,0,0,0,582.63,27.11Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.77,69.65a13.26,13.26,0,0,1,3,.36V40.12a4.91,4.91,0,0,0-4.91-4.91H72.7a4.9,4.9,0,0,0-4.9,4.91V69.66h11Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1,69.67l.43,0h10.73A12.67,12.67,0,0,1,150,70V35.21H136.1V69.67Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.35,35.21H204.41V69.66h10.87a12.91,12.91,0,0,1,3.07.39V35.21Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.57,83.13a13.91,13.91,0,0,0,.93,2.39V82.38A12.74,12.74,0,0,0,81.74,70a13.26,13.26,0,0,0-3-.36h-11A12.72,12.72,0,0,0,55.31,82.38v483A12.73,12.73,0,0,0,68,578.16H78.77A12.73,12.73,0,0,0,91.5,565.42V562a13.91,13.91,0,0,0-.93,2.39Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.59,83.13a13.69,13.69,0,0,0,1.4,3.24v-4a12.79,12.79,0,0,0-12.73-12.73H136.53l-.43,0a12.73,12.73,0,0,0-12.3,12.71v2.3c.11-.25.21-.49.3-.75V563.54c-.09-.26-.19-.5-.3-.75v2.63a12.73,12.73,0,0,0,12.73,12.74h10.73A12.73,12.73,0,0,0,160,565.42V561.1a13.69,13.69,0,0,0-1.4,3.24Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1,83.93c-.09.26-.19.5-.3.75-2.45,5.81-8.84,10-16.35,10-7.14,0-13.26-3.76-16-9.12a13.91,13.91,0,0,1-.93-2.39V564.34A13.91,13.91,0,0,1,91.5,562c2.69-5.36,8.81-9.12,16-9.12,7.51,0,13.9,4.15,16.35,10,.11.25.21.49.3.75Z",
    fill: "#16a99e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.55,69.65h-.14a12.73,12.73,0,0,0-12.59,12.72v2.3c.11-.25.21-.49.31-.75V563.54c-.1-.26-.2-.5-.31-.75v2.63a12.73,12.73,0,0,0,12.73,12.74h10.73A12.73,12.73,0,0,0,228,565.42V556a20,20,0,0,1-6.56,1.09c-8.25,0-14.93-4.73-14.93-10.57,0-4.15,3.37-7.72,8.27-9.46V427.82c-2.9-1.77-4.7-4.17-4.7-6.83l-1.4-57.73c0-5.44,7.51-9.85,16.76-9.85H228V307.33A23.75,23.75,0,0,1,208.69,284V258.44c0-12.91,8.92-19.24,19.32-23.23V82.38A12.72,12.72,0,0,0,218.35,70a12.91,12.91,0,0,0-3.07-.39Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.13,83.93c-.1.26-.2.5-.31.75-2.45,5.81-8.84,10-16.35,10-6.75,0-12.59-3.37-15.48-8.27a13.69,13.69,0,0,1-1.4-3.24V564.34a13.69,13.69,0,0,1,1.4-3.24c2.89-4.9,8.73-8.27,15.48-8.27,7.51,0,13.9,4.15,16.35,10,.11.25.21.49.31.75Z",
    fill: "#16a99e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.69,258.44V284A23.75,23.75,0,0,0,228,307.33l.28.05a23.64,23.64,0,0,0,4.15.37H401.83A23.74,23.74,0,0,0,425.57,284V258.44a23.29,23.29,0,0,0-11.72-20.27,46.3,46.3,0,0,0-11.22-3.94c-27.39-7-55-15.52-83.59-15.52-27.69,0-53.84,5.87-80.41,13.14-3.43.94-7,2-10.34,3.26l-.28.1C217.61,239.2,208.69,245.53,208.69,258.44Zm82.19-19.18h55.55a6.85,6.85,0,0,1,0,13.7H290.88a6.85,6.85,0,0,1,0-13.7Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.09,
    y: 307.75,
    width: 14.46,
    height: 45.66,
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.85,430.84a23.56,23.56,0,0,1-12.06-3V537.06a20,20,0,0,1,6.66-1.12,19.59,19.59,0,0,1,7.8,1.58V486.81h20.54v50.85a19.58,19.58,0,0,1,8.15-1.72,20,20,0,0,1,6.31,1V431.86H249.79v41.27H229.25V430.84Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.7,430.84v42.29H505.83V431.86H491.37V536.42a20.53,20.53,0,0,1,4.43-.48A19.43,19.43,0,0,1,504,537.7h1.8V486.81H524.7v50.61a20.23,20.23,0,0,1,14.46-.28V430.64a29.24,29.24,0,0,1-3.42.2Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.72,
    y: 307.75,
    width: 14.46,
    height: 45.66,
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.45,535.94a20,20,0,0,0-6.66,1.12c-4.9,1.74-8.27,5.31-8.27,9.46,0,5.84,6.68,10.57,14.93,10.57A20,20,0,0,0,228,556l.28-.09c4.8-1.76,8.08-5.3,8.08-9.39,0-3.81-2.85-7.14-7.12-9A19.59,19.59,0,0,0,221.45,535.94Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.79,537.66c-4.07,1.89-6.78,5.15-6.78,8.86,0,5.84,6.69,10.57,14.93,10.57s14.93-4.73,14.93-10.57c0-4.24-3.53-7.89-8.62-9.57a20,20,0,0,0-6.31-1A19.58,19.58,0,0,0,249.79,537.66Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.69,363.26l1.4,57.73c0,2.66,1.8,5.06,4.7,6.83a23.56,23.56,0,0,0,12.06,3h80.63c9.25,0,16.76-4.41,16.76-9.85C324.24,426.43,208.69,363.26,208.69,363.26Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.29,353.41h-2.84c-9.25,0-16.76,4.41-16.76,9.85,0,0,115.55,63.17,115.55,57.73l-1.4-57.73c0-5.44-7.5-9.85-16.76-9.85H228.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.88,353.41c-9.26,0-16.76,4.41-16.76,9.85,0,0,109.05,59.63,115.26,58,0-.1,0-.2,0-.3L437,363.26a6.06,6.06,0,0,1,.16-1.28c-1.07-4.83-8.09-8.57-16.6-8.57H339.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.37,536.42c-6.08,1.34-10.5,5.35-10.5,10.1,0,5.84,6.69,10.57,14.93,10.57s14.92-4.73,14.92-10.57c0-3.69-2.66-6.93-6.69-8.82a19.43,19.43,0,0,0-8.23-1.76A20.53,20.53,0,0,0,491.37,536.42Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.7,537.42c-4.38,1.85-7.33,5.22-7.33,9.1,0,5.84,6.68,10.57,14.92,10.57s14.93-4.73,14.93-10.57c0-4.09-3.27-7.62-8.06-9.38a20.23,20.23,0,0,0-14.46.28Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,363.26l1.4,57.73c0,.1,0,.2,0,.3-6.21,1.6-115.26-58-115.26-58,0-5.44,7.5-9.85,16.76-9.85h-.12c-9.26,0-16.76,4.41-16.76,9.85L324.39,421c0,5.44,7.51,9.85,16.76,9.85h80.63c8.66,0,15.78-3.85,16.67-8.8.88,4.95,8,8.8,16.66,8.8h80.63a29.24,29.24,0,0,0,3.42-.2c7.53-.92,13.2-4.81,13.32-9.49C549.83,425,437,363.26,437,363.26c0-5.44,7.51-9.85,16.76-9.85h-.05c-8.52,0-15.54,3.74-16.6,8.57A6.06,6.06,0,0,0,437,363.26Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,363.26S549.83,425,552.48,421.15a.24.24,0,0,0,.07-.16l-1.4-57.73c0-5.44-7.5-9.85-16.76-9.85H453.76C444.51,353.41,437,357.82,437,363.26Z",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShowerBenches, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shower_benches.3b68815c.svg";
export { ForwardRef as ReactComponent };